import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import home from "./home"

export default new Vuex.Store({
  state: {
    isAdmin: null,
    checkValues:[]
  },
 
  getters: {
    getAdmin: (state) => state.isAdmin,
  },
  mutations: {
    setAdmin(state, obj) {
      state.isAdmin = obj.isAdmin;
    },
  },
  actions: {
    setAdmin(content, payload) {
      // 增加payload参数
      return new Promise((resolve) => {
        content.commit("setAdmin", { isAdmin: payload.isAdmin });
        resolve();
      });
    },
  },
  modules: {home,},
});
